import { render, staticRenderFns } from "./DetachDealerAccountAction.vue?vue&type=template&id=5be8c3c8&scoped=true&"
import script from "./DetachDealerAccountAction.vue?vue&type=script&lang=ts&"
export * from "./DetachDealerAccountAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be8c3c8",
  null
  
)

export default component.exports